import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, DestroyRef, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { notNull } from '@app/shared';
import { Store } from '@ngrx/store';
import { filter, Observable } from 'rxjs';
import { ModalAuditActions, ModalAuditSelectors } from './store';
import { ModalAuditData } from './store/modal-audit.actions';
import { Application, ModalAuditState } from './store/modal-audit.state';

@Component({
  templateUrl: './modal-audit.component.html',
})
export class ModalAuditComponent {
  public application$: Observable<Application>;
  constructor(
    @Inject(DIALOG_DATA) private _data: ModalAuditData,
    private _store: Store<ModalAuditState>,
    private _destroyRef: DestroyRef,
    private _dialogRef: DialogRef,
  ) {
    this.application$ = this._store.select(ModalAuditSelectors.selectApplication).pipe(
      takeUntilDestroyed(this._destroyRef),
      notNull(),
      filter((application) => !!application?.uuid),
    );

    this._store.dispatch(ModalAuditActions.InitDataEffect(this._data));
  }

  public onClose() {
    this._store.dispatch(ModalAuditActions.ClearStageReducer());
    this._dialogRef.close();
  }
}
